// eslint-disable-next-line import/no-extraneous-dependencies
import gql from 'graphql-tag';

// eslint-disable-next-line import/extensions
import { FRAGMENT_PRODUCT, FRAGMENT_FILTER_BLOCK, FRAGMENT_BANNER } from './apolloFragment.js';

export const GET_LISTING_DATA = gql`
  ${FRAGMENT_PRODUCT}
  query getListingData ($slug: String!, $request: catalogSearchFilterInput, $zipcode: String) {
    listing {
      listingCategory(slug: $slug, request: $request, zipcode: $zipcode) {
        itemsCount
        perPage
        pages
        page
        header: title
        items {
            ...fragmentCatalogProduct
          ... on catalogSearchProductDynamicItem {
              items {
                  ...fragmentCatalogProduct
              }
          }
        }
      },
      topSellerProducts(categorySlug: $slug) {
        webId
        title
        brand {
          name
        }
        url
        slug
        labels
        price {
          price
          regularPrice
          finalPrice
          msrp
          showMsrp
        }
        reviews {
          number
          rating
        }
        images {
          mainImage {
            style
            alt
            src
            sources {
              media
              srcset
            }
            classes
          }
        }
      }
    }
  },
`;

export const GET_LISTING_FILTERS_DATA = gql`
  ${FRAGMENT_FILTER_BLOCK}
  ${FRAGMENT_BANNER}
  query getListingFiltersData ($slug: String!, $request: catalogSearchFilterInput) {
    listing {
      listingCategory(slug: $slug, request: $request) {
        itemsCount
        maxPrice
        minPrice
        filtersBlock {
          ...fragmentCatalogSearchFilterBlock
        }
        additionalData {
          ... on ListingCAData {
            isVirtual
            genuineSlug
            bannerData {
              desktop {
                ...fragmentBanner
              }
              mobile {
                ...fragmentBanner
              }
            }
          }
          facets {
            attributeCode
            value {
              attrValue
              attrLabel
            }
          }
          extensionParams {
            key
            value
          }
          ... on ListingBAData {
            extraChips {
              attributeCode
              value {
                attrLabel
                attrValue
              }
            }
          }
        }
      }
    }
  },
`;

export const GET_LISTING_SEO_DATA = gql`
  query getListingSeoData ($slug: String!) {
    pageMetadata(slug: $slug) {
      addons {
        ... on CPMeta {
          filters: popularFilters {
            url
            label
            internalRoute
          }
          categories: relatedCategories {
            url
            label
            internalRoute
          }
          seoData: seoBlock {
            content
            placement
          }
          articles {
            url
            image
            header: title
            shortDescription
          }
        }
      }
    }
  },
`;

export const GET_LISTING_COUNT_DATA = gql`
  query getListingCountData ($slug: String!, $request: catalogSearchFilterInput) {
    listing {
      listingCategory(slug: $slug, request: $request) {
        itemsCount
      }
    }
  },
`;

export const GET_MAIN_MENU = gql`
  query getMainMenu {
    menu {
      mainMenu {
        id
        name
        slug
        image {
          id
          src
        }
        submenu {
          id
          name
          slug
          image {
            id
            src
          }
        }
      }
    }
  },
`;

export const GET_BRAND = gql`
  query getBrands {
    menu {
      brands {
        id
        name
        slug
        featured
      }
    }
  },
`;

export const MATTRESS_FINDER = gql`
  query mattressFinder {
    listing {
      mattressFinder {
        attributeCode
        name
        caption
        label
        items {
          name
          icon
          description
          value
        }
      }
    }
  }
`;

export const RECENTLY_VIEWED = gql`
  ${FRAGMENT_PRODUCT}
  query RecentlyViewed($webIds: [String!]) {
    listing {
      recentlyViewed(webIds: $webIds) {
        ...fragmentCatalogProduct
          ... on catalogSearchProductDynamicItem {
              items {
                  ...fragmentCatalogProduct
              }
          }
      }
    }
  }
`;
